import { render, staticRenderFns } from "./BrandUpdateImageDialog.vue?vue&type=template&id=c91d7ee8&scoped=true"
import script from "./BrandUpdateImageDialog.vue?vue&type=script&lang=ts"
export * from "./BrandUpdateImageDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c91d7ee8",
  null
  
)

export default component.exports